// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2RigH","col":"styles_col__3PiKt"};